import worker from '@/urls/worker'
import {
  sendGetRequest,
} from '@/helper/requests'

const state = {

  organization: {
    organizationDetail: null,
    loadingOrganizationDetail: false,
    error: null,
    organizationTree: null,
    loadingOrganizationTree: false,
    errorTree: null
  }
}

const getters = {
  getOrganization: state => state.organization.organizationDetail,
  getOrganizationTree: state => state.organization.organizationTree,
  isLoadingOrganizationDetail: state => state.organization.loadingOrganizationDetail,
  isLoadingOrganizationTree: state => state.organization.loadingOrganizationTree,
}

const actions = {
  loadOrganization: ({ commit }, { url, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает информацию об организации сотрудника
     * @param {Object} context - контекст Vuex
     * @param {string} url - URL для загрузки
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    commit('SET_ORGANIZATION_LOADING')
    if (!url) url = worker.WORKER.ORGANIZATION()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_ORGANIZATION', [data[0]])
        commit('SET_ORGANIZATION_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_ORGANIZATION_ERROR', data)
        commit('SET_ORGANIZATION_LOADING_END')
        catcher(data, url)
      }
    )
  },
  loadOrganizationTree: ({ commit }, { url, organization_id, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает организационное дерево
     * @param {Object} context - контекст Vuex
     * @param {string} url - URL для загрузки
     * @param {string|number} organization_id - идентификатор организации
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    commit('SET_ORGANIZATIONTREE_LOADING')
    if (!url) url = worker.WORKER.ORGANIZATION_TREE(organization_id)
    sendGetRequest(
      url, (data, url) => {
        // Преобразование JSON: замена имен переменных для вывода структуры через библиотеку vue3-tree
        let stringified = JSON.stringify(data)
        stringified = stringified.replaceAll('name', 'label')
        stringified = stringified.replaceAll('children', 'nodes')
        stringified = stringified.replaceAll('pk', 'id')
        const jsonObject = JSON.parse(stringified)

        commit('SET_ORGANIZATIONTREE', jsonObject)
        commit('SET_ORGANIZATIONTREE_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_ORGANIZATIONTREE_ERROR', data)
        commit('SET_ORGANIZATIONTREE_LOADING_END')
        catcher(data, url)
      }
    )
  },
}

const mutations = {
  SET_ORGANIZATION: (state, value) => {
    /**
     * Устанавливает организацию сотрудника
     * @param {Object} state - состояние хранилища
     * @param {Array} value - данные организации
     */
    state.organization.organizationDetail = value
  },
  SET_ORGANIZATION_LOADING: (state) => {
    /**
     * Включает состояние загрузки информации об организации
     * @param {Object} state - состояние хранилища
     */
    state.organization.loadingOrganizationDetail = true
  },
  SET_ORGANIZATION_LOADING_END: (state) => {
    /**
     * Выключает состояние загрузки информации об организации
     * @param {Object} state - состояние хранилища
     */
    state.organization.loadingOrganizationDetail = false
  },
  SAVE_ORGANIZATION_ERROR: (state, error) => {
    /**
     * Сохраняет ошибки при работе с организацией
     * @param {Object} state - состояние хранилища
     * @param {Object} error - объект ошибки
     */
    state.organization.error = error
  },
  SET_ORGANIZATIONTREE: (state, value) => {
    /**
     * Устанавливает организационное дерево
     * @param {Object} state - состояние хранилища
     * @param {Object} value - структура организационного дерева
     */
    state.organization.organizationTree = value
  },
  SET_ORGANIZATIONTREE_LOADING: (state) => {
    /**
     * Включает состояние загрузки организационного дерева
     * @param {Object} state - состояние хранилища
     */
    state.organization.loadingOrganizationTree = true
  },
  SET_ORGANIZATIONTREE_LOADING_END: (state) => {
    /**
     * Выключает состояние загрузки организационного дерева
     * @param {Object} state - состояние хранилища
     */
    state.organization.loadingOrganizationTree = false
  },
  SAVE_ORGANIZATIONTREE_ERROR: (state, error) => {
    /**
     * Сохраняет ошибки при работе с организационным деревом
     * @param {Object} state - состояние хранилища
     * @param {Object} error - объект ошибки
     */
    state.organization.errorTree = error
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
